import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { CustomAddress } from 'src/app/models/ApplicantDataModels/CustomAddress';
import { CustomAlias } from 'src/app/models/ApplicantDataModels/CustomAlias';
import { ObjectUpdatePayload, Screening, ScreeningInvite, ScreeningLight } from 'src/app/models/screeningInvite';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { ScreeningService } from '../../services/screening.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { ArgyleViewBagResponse } from 'src/app/models/Argyle';

@Component({
  selector: 'app-screening-edit',
  templateUrl: './screening-edit.component.html',
  styleUrls: ['./screening-edit.component.less']
})
export class ScreeningEditComponent implements OnInit, OnDestroy {

  @Input() screeningId :number;
  @Input() argyleData: ArgyleViewBagResponse;
  screening : Screening;
  
  @Input() aliases : CustomAlias[] = [];
  @Input() addresses : CustomAddress[] = [];
  @Output() saveStateChanged : EventEmitter<boolean> = new EventEmitter<boolean>();
  originalValues : any;
  @ViewChild('screeningEditForm', {}) ngForm: NgForm;

  newAddress : CustomAddress = new CustomAddress();
  newAlias : CustomAlias = new CustomAlias();
  incomeChanged : boolean = false;
  rentChanged : boolean = false;
  displayDate : string;
  showalertIncome : boolean = false;
  constructor(private appData : ApplicantDataService, 
    private toast : ToastrService, 
    public filtering : FilteringService, 
    public screeningService : ScreeningService,
    public modalService: NgbModal,
    private auth: AuthService) { }

    
  public get model() : Screening {
    return this.screening;
  }
    
  ngOnInit() {
    this.screeningService.GetScreeningById(this.screeningId).pipe(take(1)).subscribe(_ =>{
      this.screening = _;
      this.screeningService.GetScreeningInvite(this.screening.screeningToken).pipe(take(1)).subscribe((inv: ScreeningInvite)=>{
        this.screening.invitation = inv;
        this.originalValues = JSON.parse(JSON.stringify(inv));
      })
    },()=>{ this.toast.error('Error Loading Screening')});

    // this.ngForm.controls['phoneNumber']?.valueChanges.subscribe(vl=>{
    //   this.showalertIncome = true;
    // })
  }

  incomeVerFieldChange(name : string,value: any) {
    // console.log('income field changes',name, value);
    console.log('original :', this.originalValues[name])
    console.log('current :', this.screening.invitation[name])
    if(this.originalValues[name] != this.screening.invitation[name] && this.argyleData.argyleInvite && this.argyleData.argyleInvite.inviteStatus == 'sent')  this.showalertIncome = true;
  }

  ngOnDestroy(): void {
    this.ngForm.resetForm('');
  }

  saveScreening() {
    // this.screening.ssn = this.screeningService.formatSSN(this.screening.ssn);
    // this.screening.invitation.telephone = this.screeningService.formatPhoneNumber(this.screening.invitation.telephone);
    console.log(this.ngForm);
    let inviteEdited: boolean = false;

    if(this.ngForm.valid && this.ngForm.touched) {
      if(this.ngForm.controls['invitedParty'].touched 
      || this.ngForm.controls['phoneNumber'].touched) inviteEdited = true;

      this.screeningService.UpdateScreeningPIT(this.model).subscribe((res : boolean) => {
        
        //1. if the update failed, notify user and bail
        if(res === false) {
          this.toast.error('Screening failed to update!', '', { closeButton: true, disableTimeOut: true });
          return;
        }

        //3. with PIT logging, we need tos end the invite to a separate endpoint if changes were made ^^^
        if(inviteEdited) {
          // RIQ-4406: so if they modify the invite then we need to revoke any existing ones and send otu a new one.
          this.model.invitation.screeningId = this.model.id; //set this here for processing the event on the BE
          this.screeningService.UpdateScreeningInvitePIT(this.model.invitation).subscribe( res =>
            {
              if(res && this.showalertIncome) {
                this.appData.ReprocessArgyleInvite(this.model, this.model.invitation.id).subscribe(()=>{
                  this.toast.success('Income Verification sent to new phone/email');
                },()=>{
                  this.toast.error('Error sending new income ver');
                });
                this.toast.success('Screening updated!', '');
                this.modalService.dismissAll();
              }
            }, err => this.toast.error('Screening Invitation failed to update!', '', { closeButton: true, disableTimeOut: true }))
        } else {
          this.toast.success('Screening updated!', '');
          this.modalService.dismissAll();
        }
      },
      err => this.toast.error('Screening failed to update!', '', { closeButton: true, disableTimeOut: true }));
    }
  }
}
